import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useAlarmReport } from '../useAlarmReport';
import { AlarmReportCriteria, AlarmReportResults } from '../AlarmReportContent';

export const AlarmEventReportModal = ({ reportPayload, criteriaSummary, onClose, onCreateRule, alarmRuleReportService, alarmNotificationService, dateFilter, $translate }) => {
  const [requests] = useState(() => ({
    request: () => alarmRuleReportService.runAsReportPaged(reportPayload),
    exportCsv: () => alarmRuleReportService.exportRunAsReportCsv(reportPayload),
    exportExcel: () => alarmRuleReportService.exportRunAsReportExcel(reportPayload),
  }));
  const report = useAlarmReport({
    ...requests,
    service: alarmRuleReportService,
    notifications: alarmNotificationService,
    errorTitle: 'Failed to run alarm report',
    exportErrorTitle: 'Failed to export alarm report',
  });
  const close = () => { report.cancel(); onClose(); };
  const createRule = () => { close(); onCreateRule(); };
  const dateWindow = criteriaSummary.dataWindowDisplay || {};
  const interval = criteriaSummary.intervalDisplay || {};
  const isDate = dateWindow.mode === 'date';
  const startDate = reportPayload.eventFilter.startDate;
  const endDate = reportPayload.eventFilter.endDate;

  return (
    <div className="alarm-event-view-modal" data-testid="alarm-event-report-modal">
      <div className="modal-header">
        <h3 className="modal-title">Alarm Report</h3>
        <button type="button" className="close" aria-label="close" onClick={close} data-testid="alarm-report-close-button"><span aria-hidden="true">x</span></button>
      </div>
      <div className="modal-body">
        <section className="alarm-report-criteria" data-testid="alarm-report-criteria">
          <h4>Report Criteria</h4>
          <div className="alarm-report-criteria__grid alarm-report-criteria__grid--inline">
            <AlarmReportCriteria summary={criteriaSummary}>
              {isDate ? (
                <>
                  <p data-testid="alarm-report-start-date"><strong>Start Date:</strong> {startDate ? dateFilter(startDate, 'dd/MM/yyyy HH:mm') : 'Any'}</p>
                  <p data-testid="alarm-report-end-date"><strong>End Date:</strong> {endDate ? dateFilter(endDate, 'dd/MM/yyyy HH:mm') : 'Any'}</p>
                </>
              ) : <p data-testid="alarm-report-data-window"><strong>Data Window:</strong> {dateWindow.value} {dateWindow.mode === 'day' ? 'days' : dateWindow.mode}</p>}
              <p><strong>Threshold Count:</strong> {reportPayload.occurrence}</p>
              <p><strong>Within:</strong> {interval.value} {interval.unit}</p>
            </AlarmReportCriteria>
          </div>
        </section>
        <AlarmReportResults report={report} prefix="alarm-report" translate={$translate} />
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={close} data-testid="alarm-report-cancel-button"><i className="fas fa-times fa-fw" aria-hidden="true" /> Close</button>
        <button type="button" className="btn btn-primary" onClick={createRule} data-testid="alarm-report-create-rule-button"><i className="fas fa-plus fa-fw" aria-hidden="true" /> Create Rule</button>
      </div>
    </div>
  );
};

AlarmEventReportModal.propTypes = {
  reportPayload: PropTypes.object.isRequired,
  criteriaSummary: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateRule: PropTypes.func.isRequired,
  alarmRuleReportService: PropTypes.object.isRequired,
  alarmNotificationService: PropTypes.object.isRequired,
  dateFilter: PropTypes.func.isRequired,
  $translate: PropTypes.func.isRequired,
};